import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import DefaultModuleLayout from './DefaultModuleLayout';
import StandInManagementSidebar from '../navigation/StandInManagementSidebar';

function StandInManagementLayout() {
    useEffect(() => {
        localStorage.setItem('selectedModule', 'Stand-In Management');
    }, []);

    return (
        <DefaultModuleLayout>
            <StandInManagementSidebar />
            <div className="w-full bg-light-grey overflow-x-hidden overflow-y-scroll pl-[78px] h-[calc(100vh-64px)]">
                <Outlet />
            </div>
        </DefaultModuleLayout>
    );
}

export default StandInManagementLayout;
